
import { onMounted, ref, nextTick } from "vue";
import { useRouter } from "vue-router";
import Toast from "vant/es/toast";
import "vant/es/toast/style";
import CountyOne from "../components/CountyOne.vue";
import ClassOne from "../components/ClassOne.vue";
import axios from "axios";
import watermark from "watermark-dom";
import '../utils/flex.js'

const getQueryString = (name: string) => {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
        return unescape(r[2]);
    }
    return null;
};

export default {
    components: {
        CountyOne,
        ClassOne,
    },
    setup() {
        const router = useRouter();
        let data: any = ref({});
        let type = ref(-1);
        const key = getQueryString("id");
        // 登录token（小程序webview拼在URL上），透传给下载预览页，用于upload-token等需登录态的接口
        const tk = getQueryString("tk");
        const initData = async () => {
            const res: any = await axios.post(
                "/api/activity/link-data-export",
                {
                    key,
                }
            );
            if (res.data.code !== 0) {
                Toast(res.data.msg);
                return;
            }
            data.value = res.data.data;
            type.value = data.value.type;
            document.title = data.value.name;
            nextTick(() => {
                const option = {
                    watermark_id: "wm_div_id", //水印总体的id
                    watermark_prefix: "mask_div_id", //小水印的id前缀
                    watermark_txt: data.value.bd_name, //水印的内容
                    watermark_x_space: 10, //水印x轴间隔
                    watermark_y_space: 5, //水印y轴间隔
                    watermark_fontsize: ".3rem", //水印字体大小
                    watermark_alpha: 0.1, //水印透明度，要求设置在大于等于0.005
                    watermark_parent_node: "data-index-body-one", //水印插件挂载的父元素element,不输入则默认挂在body上
                };
                watermark.init(option);
            });
        };
        const subText = () => {
            switch (data.value.type) {
                case 0:
                    return `共有${data.value.list.length}个年级，${
                        data.value.list.flatMap((e: any) => e.list).length
                    }个班级`;
                case 1:
                case 2:
                case 3:
                    return `共有${data.value.list.length}个学校，${
                        data.value.list.flatMap((e: any) => e.description_list)
                            .length
                    }个班级`;
                // case 3:
                //     return `共有${data.value.list.length}个年级，${
                //         data.value.list.flatMap((e: any) => e.list).length
                //     }个班级`;
            }
        };

        // 跳转下载预览页
        const goDownload = () => {
            router.push({ path: "/download", query: { id: key, tk } });
        };

        onMounted(() => {
            initData();
        });

        return {
            data,
            subText,
            goDownload,
        };
    },
};
